var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignmentByBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-assignment-return"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 3.40495H12.35C12 2.43828 11.0833 1.73828 10 1.73828C8.91667 1.73828 8 2.43828 7.65 3.40495H4.16667C3.25 3.40495 2.5 4.15495 2.5 5.07161V16.7383C2.5 17.6549 3.25 18.4049 4.16667 18.4049H15.8333C16.75 18.4049 17.5 17.6549 17.5 16.7383V5.07161C17.5 4.15495 16.75 3.40495 15.8333 3.40495ZM10 3.40495C10.4583 3.40495 10.8333 3.77995 10.8333 4.23828C10.8333 4.69661 10.4583 5.07161 10 5.07161C9.54167 5.07161 9.16667 4.69661 9.16667 4.23828C9.16667 3.77995 9.54167 3.40495 10 3.40495ZM13.3333 13.4049H10V15.9049L6.125 12.0299C5.95833 11.8633 5.95833 11.6049 6.125 11.4383L10 7.57161V10.0716H13.3333V13.4049Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentByBlue);
export default __webpack_public_path__ + "static/media/assignment-by-blue.c45c96e4d822afb7900309c03c0b3e98.svg";
export { ForwardRef as ReactComponent };